import React, {useState, useEffect, useContext} from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { collection, getDoc, addDoc, updateDoc, doc, deleteDoc, orderBy } from 'firebase/firestore';
import { db } from '../firebase';
import { onSnapshot } from 'firebase/firestore';
import TextField from '@mui/material/TextField';
import { Box, Button } from '@mui/material';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@mui/material/IconButton';
import format from 'date-fns/format';
import AdminNavbar from '../components/AdminNavbar';
import {Link} from "react-router-dom";
import { AlertsContext } from '../AlertsContext';

function EditUserData() {
    const {id} = useParams()
    const [user, setUser] = useState();
    const navigate = useNavigate();
    const { setAlert } = useContext(AlertsContext);

    const docRef = doc(db, `users/${id}`)
    useEffect(() => {
        // get user info   
        getDoc(docRef).then((doc) => {
            if (doc.exists()) {
                console.log("Document data:", doc.data());
                setUser(doc.data())
            } else {
                // doc.data() will be undefined in this case
                console.log("No such document!");
            }
        });
    }, []);
  
   
     function handleSubmit(event) {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        updateDoc(docRef, {
            firstName: data.get('firstName'),
            lastName: data.get('lastName'),
            email: data.get('email'),
            mobile: data.get('mobile'),
            postcode: data.get('postcode')
        });

        setAlert("User updated successfully!")
    }

    return (
        <>
        <AdminNavbar />
        {/* <Button color="inherit" variant="text" onClick={() => navigate(-1)}>Go Back</Button> */}
        {user &&
        <Box component="form" noValidate onSubmit={handleSubmit} sx={{ margin:'20px 20px', textAlign:'center'}}>
        
                <TextField
                className='adminInput'
                name="firstName"
                value={user.firstName}
                onChange={(event) => setUser({...user, firstName: event.target.value} )}
                label="First Name"
                autoFocus
                />
                <br />
                <TextField
                className='adminInput'
                name="lastName"
                value={user.lastName}
                onChange={(event) => setUser({...user, lastName: event.target.value} )}
                label="Last Name"
                autoFocus
                />
                <br />
                <TextField
                className='adminInput'
                name="email"
                value={user.email}
                onChange={(event) => setUser({...user, email: event.target.value} )}
                label="Email"
                autoFocus
                />
                <br />
                <TextField
                name="mobile"
                className='adminInput'
                value={user.mobile}
                onChange={(event) => setUser({...user, mobile: event.target.value} )}
                label="Mobile"
                autoFocus
                />
                <br />
                <TextField
                name="postcode"
                className='adminInput'
                value={user.postcode}
                onChange={(event) => setUser({...user, postcode: event.target.value} )}
                label="Postcode"
                autoFocus
                />
                <br />
                <Button 
                type='submit' 
                variant="contained"
                sx={{ mt: 3, mb: 2 }}   
                onSubmit={handleSubmit}
                >
                Save changes
            </Button>  

            <h3>Purchases</h3>

            <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper',margin:'0 auto', textAlign:'center' }}>
                {/* sort array of objects by date DESC */}
                {user?.purchases.sort((a,b) => b.date - a.date).map((purchase, index) => (
                    <ListItem
                    key={index}
                    disableGutters
                    secondaryAction={
                        <Link to={"/edit-purchase/" + purchase.id}>
                            <IconButton aria-label="comment">
                            <EditIcon />
                            </IconButton>
                        </Link>
                    }
                    >
                    <ListItemText primary={format(purchase.date.toDate(), 'dd/MM/yyyy HH:mm')} />
                    </ListItem>
                ))}
            </List>
        </Box>
        }
        </>
    );
}

export default EditUserData;